document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = document.getElementById(select.dataset.priceTarget || '');
  if (price && option.dataset.price) {
    const compare = option.dataset.compare;
    price.innerHTML =
      (compare ? '<s class="price-compare">' + compare + '</s> ' : '') +
      '<span class="price-item">' + option.dataset.price + '</span>' +
      (compare ? '<span class="visually-hidden"> Sale</span>' : '');
  }
});

function setGallerySlide(gallery, index) {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  if (!slides.length) return;
  const next = (index + slides.length) % slides.length;
  slides.forEach((slide) => {
    const active = Number(slide.dataset.gallerySlide) === next;
    slide.hidden = !active;
    slide.classList.toggle('is-active', active);
  });
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.classList.toggle('is-active', Number(thumb.dataset.galleryThumb) === next);
  });
  gallery.dataset.galleryIndex = next;
}

document.addEventListener('click', (event) => {
  const gallery = event.target.closest('[data-gallery]');
  if (!gallery) return;
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) { setGallerySlide(gallery, Number(thumb.dataset.galleryThumb)); return; }
  const current = Number(gallery.dataset.galleryIndex) || 0;
  if (event.target.closest('[data-gallery-prev]')) { setGallerySlide(gallery, current - 1); return; }
  if (event.target.closest('[data-gallery-next]')) { setGallerySlide(gallery, current + 1); }
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-theme-toggle]');
  if (!toggle) return;
  const nextTheme = document.documentElement.dataset.colorTheme === 'light' ? 'dark' : 'light';
  document.documentElement.dataset.colorTheme = nextTheme;
  try { localStorage.setItem('calm-days-theme-v2', nextTheme); } catch (error) {}
  updateThemeToggle();
});

function updateThemeToggle() {
  const isLight = document.documentElement.dataset.colorTheme === 'light';
  document.querySelectorAll('[data-theme-toggle]').forEach((toggle) => {
    toggle.setAttribute('aria-label', isLight ? 'Switch to midnight theme' : 'Switch to light theme');
    toggle.setAttribute('aria-pressed', isLight ? 'true' : 'false');
    const label = toggle.querySelector('[data-theme-label]');
    if (label) label.textContent = isLight ? 'Midnight' : 'Light';
  });
}

function prepareCarouselTrack(track) {
  if (!track || track.dataset.marqueeReady || track.children.length < 2) return;
  [...track.children].forEach((card) => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a, button, input, select').forEach((item) => item.setAttribute('tabindex', '-1'));
    track.appendChild(clone);
  });
  track.dataset.marqueeReady = 'true';
}

const marqueeSpeed = 1; // constant auto-scroll speed
let marqueeStarted = false;
let marqueeHover = false; // slow down while the cursor is over the row

document.addEventListener('pointerover', (event) => {
  if (event.target.closest('[data-carousel-track]')) marqueeHover = true;
});
document.addEventListener('pointerout', (event) => {
  const track = event.target.closest('[data-carousel-track]');
  if (track && !track.contains(event.relatedTarget)) marqueeHover = false;
});

// While the user is swiping/scrolling a track, stop driving scrollLeft so we
// don't fight their finger (the "wobble"). Resume shortly after they let go.
function markUserScrolling(event) {
  const track = event.target.closest('[data-carousel-track]');
  if (!track) return;
  track.dataset.userScrolling = 'true';
  clearTimeout(track._resumeTimer);
  track._resumeTimer = setTimeout(() => { delete track.dataset.userScrolling; }, 900);
}
['pointerdown', 'touchstart', 'touchmove', 'wheel'].forEach((type) => {
  document.addEventListener(type, markUserScrolling, { passive: true });
});

function startProductMarquees() {
  document.querySelectorAll('[data-carousel-track]').forEach(prepareCarouselTrack);
  if (marqueeStarted) return;
  marqueeStarted = true;
  let previousTime = performance.now();
  const move = (time) => {
    const dt = Math.min(time - previousTime, 40);
    previousTime = time;
    if (marqueeSpeed !== 0) {
      document.querySelectorAll('.carousel-panel.is-active [data-carousel-track]').forEach((track) => {
        const half = track.scrollWidth / 2;
        if (half < 1) return; // nothing to scroll (content fits)
        if (track.dataset.userScrolling) { // user is swiping: follow them, don't fight
          track.dataset.marqueePos = ((track.scrollLeft % half) + half) % half;
          return;
        }
        let pos = (parseFloat(track.dataset.marqueePos) || 0) + dt * .035 * marqueeSpeed * (marqueeHover ? .25 : 1);
        pos = ((pos % half) + half) % half; // wrap seamlessly in both directions
        track.dataset.marqueePos = pos;
        track.scrollLeft = pos;
      });
    }
    requestAnimationFrame(move);
  };
  requestAnimationFrame(move);
}

document.addEventListener('DOMContentLoaded', () => {
  updateThemeToggle();
  startProductMarquees();
});
// Theme editor re-renders sections without a full reload: re-prepare tracks and ensure the loop is running.
document.addEventListener('shopify:section:load', startProductMarquees);
if (document.readyState !== 'loading') startProductMarquees();
